// extracted by mini-css-extract-plugin
var _1 = "ScaledElementSkeleton_item__7ff36";
var _2 = "ScaledElementSkeleton_root__e95e5";
export { _1 as "item", _2 as "root" }
